import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {RestaurantInterface} from "../interfaces/restaurant.interface";
import {WorkingHoursInterface} from "../../app/restaurant/restaurant-settings/interfaces/working-hours.interface";
import {LocalStorageService} from "./local-storage.service";
import {AuthService} from "./auth.service";
import {Store} from "@ngrx/store";
import {
    ClearStore,
    GetRestaurants,
    GetSubscription,
    RefreshCurrentRestaurant,
    SetCurrentRestaurant
} from "../store/store.actions";
import {selectCurrentRestaurant, selectRestaurants} from "../store/store.selectors";
import {DaysHoursInterface} from "../interfaces/days-hours.interface";

@Injectable({
    providedIn: 'root'
})
export class RestaurantService {
    currentRestaurant: RestaurantInterface;
    allRestaurants: RestaurantInterface[] = [];

    constructor(
        private http: HttpClient,
        private storage: LocalStorageService,
        private authService: AuthService,
        private store: Store
    ) {
        this.store.select(selectCurrentRestaurant).subscribe(result => {
            this.currentRestaurant = result;
            this.store.dispatch(GetSubscription());
        })
        this.store.select(selectRestaurants).subscribe(result => {
            this.allRestaurants = result;
        })
    }

    refreshData() {
        this.store.dispatch(GetRestaurants());
        this.store.dispatch(RefreshCurrentRestaurant())
    }

    initializeData(): Promise<true> {
        return new Promise(async resolve => {
            if (!this.authService.isLogged()) {
                return resolve(true);
            }

            this.store.dispatch(GetRestaurants())

            await Promise.all([
                this.authService.refreshUserProfile()
            ])

            return resolve(true);
        })
    }

    clearData() {
        this.store.dispatch(ClearStore())
    }

    changeCurrentRestaurant(id: number, refreshPage = false) {
        this.store.dispatch(SetCurrentRestaurant({restaurant: this.allRestaurants.find((r) => r.id === id) || this.allRestaurants[0]}))
        if (refreshPage) {
            window.location.reload();
        }
    }

    fetchAllRestaurants() {
        return this.http.get<RestaurantInterface[]>('/api_company/settings/restaurant');
    }

    getRestaurantInfo(id: number) {
        return this.http.get<RestaurantInterface>(`/api_company/settings/restaurant/${id}`)
    }

    fetchWorkingHours(): Promise<DaysHoursInterface> {
        return new Promise(async resolve => {
            const id = this.currentRestaurant.id;

            this.http.get<DaysHoursInterface>(`/api_company/settings/restaurant/${id}/working-hours`).subscribe((response) => {
                return resolve(response);
            });
        })
    }

    update(data: object, restaurantId: number = null): Promise<RestaurantInterface>  {
        return new Promise(async resolve => {
            const id = restaurantId ? restaurantId : this.currentRestaurant.id;

            this.refreshData();
            this.http.patch<RestaurantInterface>(`/api_company/settings/restaurant/${id}`, data).subscribe((response) => {
                return resolve(response);
            });
        })
    }

    updateSettings(settings: object, restaurantId: number = null): Observable<RestaurantInterface> {
        const id = restaurantId ? restaurantId : this.currentRestaurant.id;

        this.refreshData();
        return this.http.patch<RestaurantInterface>(`/api_company/settings/restaurant/${id}`, {settings});
    }

    updateWorkingHours(daysHours: DaysHoursInterface): Promise<DaysHoursInterface> {
        return new Promise(async resolve => {
            const id = this.currentRestaurant.id;

            this.http.patch<DaysHoursInterface>(`/api_company/settings/restaurant/${id}/working-hours`, daysHours).subscribe((response) => {
                return resolve(response);
            });
        })
    }
}
